import { Form } from "@unform/web";
import { useEffect, useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";

import UseServices from "Hooks/UseServices";

import Button from "Components/Global/Buttons";

import ConversationMessages from "../ConversationMessages";
import ConversationModal from "../ConversationModal";
// import ConversationForm from "../ConversationForm";
import * as S from "./styles";

const Conversations = ({ projectId }) => {
  const { api } = UseServices();

  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);

  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    getProjectConversations(projectId);

    // eslint-disable-next-line
  }, []);

  const getProjectConversations = (project_id) => {
    api
      .post("/projects/conversations", {
        project_id: project_id,
      })
      .then((response) => {
        const conversations = response.data?.conversations;

        setConversations(conversations);
      })
      .catch((error) => {
        return HTTPErrorCallback(error);
      });
  };

  return selectedConversation ? (
    <ConversationMessages
      projectId={projectId}
      conversation={selectedConversation}
      setConversation={setSelectedConversation}
    />
  ) : (
    <S.Wrapper>
      {openModal ? (
        <ConversationModal
          projectId={projectId}
          setOpenModal={setOpenModal}
          getProjectConversations={getProjectConversations}
        />
      ) : null}
      <Form>
        <S.Section>
          <span>Mensagens</span>
          <hr />
        </S.Section>

        <S.Buttons>
          <div />

          <Button
            type="button"
            text="Criar Conversa"
            onClick={() => setOpenModal(true)}
          />
        </S.Buttons>

        {!conversations.length ? (
          <span>Nenhuma conversa encontrada.</span>
        ) : null}

        <S.Conversations>
          {conversations.map((conversation) => (
            <S.Conversation
              key={conversation.id}
              onClick={() => setSelectedConversation(conversation)}
            >
              <S.ConversationInfos>
                <h2>{conversation?.target_user.full_name}</h2>

                {conversation.unread_messages ? (
                  <span>
                    <strong>{conversation.unread_messages}</strong> mensagens
                    não lidas
                  </span>
                ) : null}
              </S.ConversationInfos>
            </S.Conversation>
          ))}
        </S.Conversations>
      </Form>
    </S.Wrapper>
  );
};

export default Conversations;
